<cp-base-notification contentClassName="danger" wrapperClassName="danger">
  <ng-container header>
    <ui-svg-icon
      iconClassName="icon-notification--expired"
      svgId="alert-filled"
    ></ui-svg-icon>
    <span>Your compliance has expired!</span>
  </ng-container>
  <ng-container *ngIf="isNotCompliancePage" cta>
    <a
      class="compliance-expired-notification__cta__link"
      routerLink="/compliance"
      >Update Now<span
        class="compliance-expired-notification__cta__link__chevron"
      ></span
    ></a>
  </ng-container>
  <ng-container content>
    <span class="compliance-expired-notification--bold"
      >You cannot work with us until you update your compliance.</span
    >
    Please update it as soon as possible. Any promotions available to you have
    now expired. They will be available again when you update your compliance.
  </ng-container>
</cp-base-notification>
